import AlbumsByDownloadCodeMix from "../mixins/albums/GetAlbumsByDownloadCode";
import AlbumsByTagMix from "../mixins/albums/GetAlbumsByTag";

export default {
    mixins: [AlbumsByDownloadCodeMix, AlbumsByTagMix],
    data: () => ({
        modalUnlockPark: false,
        modalDeleteTags: false,
        deleteTags: {
            tags: [],
            parkId: "",
            visitDate: "",
            uuid: "",
        },
        unlockPark: {
            idx: null,
            code: null,
            parkId: null,
            selectedParks: null,
            availableParks: null,
        },
        albumComponent: "",
    }),
    computed: {},
    methods: {
        async updateExistingSales() {
            // Verificamos las ventas existentes y las recuperamos
            const sales = Object.values(this.$store.state.albumes).filter(
                (item) => item.Type === 0
            );

            // Actualizamos una venta por una
            sales.map(async (item, idx) => {
                await updateAlbum(item.code);
            });
        },
        /**
         * It returns the index of the album to be removed from the store
         * @param code - The code of the album to be removed.
         * @returns The index of the album to be removed.
         */
        getIdxAlbumToRemove(code) {
            const idx = Object.values(this.$store.state.albumes).findIndex(
                (item) => item.code == code
            );

            return idx;
        },
        /**
         * It checks if the album is already in the shopping cart.
         * @param code - The code of the album to be checked.
         * @returns A boolean value.
         */
        existAlbumInShoppingCart(code) {
            // El code puede contener Codigo de descarga | Room | Tag
            code = code.toString();
            // Verificamos si existe un codigo en el carrito
            const hasSome = Object.keys(this.$store.state.shoppingCart).some(
                (item) => item === code
            );

            return hasSome;
        },
        /**
         * It updates the album in the shopping cart.
         * @param code - The code of the album to be updated
         */
        async updateAlbum(code) {
            try {
                this.$store.dispatch("setLoading", true);

                const parameters = {
                    type: 0,
                    params: { JoinedCode: code },
                };
                /* Calling the API to get the albums by email. */
                const response = await this.$store.dispatch(
                    "getAlbums",
                    parameters
                );
                

                if (!response[0].PhotoExperiences.length) {
                    this.$store.dispatch("setLoading", false);
                    Vue.$toast.open({
                        message: this.$t("Validations.code_dont_have_parks"),
                        type: "error",
                    });
                    this.$store.dispatch("setLoading", false);

                    return;
                }

                if (this.existAlbumInShoppingCart(code)) {
                    this.$store.dispatch("removeItemShoppingCart", code);
                }

                const idxAlbum = this.getIdxAlbumToRemove(code);
                
                let albumData = this.albumsByDownloadCode(response[0]);
                this.$store.dispatch("updateAlbum", { idxAlbum, albumData });
                this.$store.dispatch("updateAlbumComponent", false);
                this.$store.dispatch("setLoading", false);

                Vue.$toast.open({
                    message: this.$t("albums.album_update"),
                    type: "success",
                });
            } catch (error) {
                
                this.$store.dispatch("setLoading", false);

                Vue.$toast.open({
                    message: this.$t("albums.error_album_update"),
                    type: "error",
                });
            }
        },
        /**
         * The function is called when the user clicks on the "Unlock Park" button. It sends a request
         * to the server with the park's id, the code the user entered, and the user's id. If the code
         * is correct, the server will add the park to the user's list of visited parks
         */
        async addVisitPark() {
            try {
                this.$store.dispatch("setLoading", true);
                const parameters = {
                    idx: parseInt(this.unlockPark.idx),
                    joinedCode: this.unlockPark.code.toString(),
                    parkId: parseInt(this.unlockPark.parkId),
                };
                const response = await this.$store.dispatch(
                    "addVisitPark",
                    parameters
                );

                
                Vue.$toast.open({
                    message: this.$t("albums.park_is_unlocked"),
                    type: "success",
                });

                this.modalUnlockPark = false;
                this.$store.dispatch("setLoading", false);
            } catch (error) {
                this.$store.dispatch("setLoading", false);
                this.modalUnlockPark = false;
                
                Vue.$toast.open({
                    message: this.$t("albums.error_park_is_unlocked"),
                    type: "error",
                });
            }
        },
        /**
         * "If the user has selected the maximum number of parks, then show a modal to unlock more
         * parks."
         *
         * The function is called when the user clicks on a park
         * @param idx - The index of the album in the store.
         * @param parkId - The park id that is being unlocked
         */
        unlockParks(idx, parkId) {
            let album = this.$store.state.albumes[idx];
            let selectedParks = album.selectedParks.length;
            let availableParks = album.getCode.AvailableParks;
            let code = album.code;

            this.unlockPark.idx = idx;
            this.unlockPark.availableParks = availableParks;
            this.unlockPark.selectedParks = selectedParks;
            this.unlockPark.code = code;
            this.unlockPark.parkId = parkId;

            this.modalUnlockPark = true;
        },
        /**
         * If the number of selected parks is equal to the number of available parks, then the album is
         * for sale
         * @param idx - The index of the album in the albumes array.
         * @returns A boolean value.
         */
        isParkForSale(idx) {
            let album = this.$store.state.albumes[idx];
            let selectedParks = album.selectedParks.length;
            let availableParks = album.getCode.AvailableParks;

            return selectedParks >= availableParks;
        },
        /**
         * The function returns the order status of a specific album in the store.
         * @param idx - idx is a parameter that represents the index of an album in the albumes array
         * stored in the Vuex store.
         * @returns The function `isPostventaOrder` is returning the `order` property of the album
         */
        isPostventaOrder(idx){
            let album = this.$store.state.albumes[idx];

            return album.order;
        },
        deleteTagsAlbum(item) {
            this.modalDeleteTags = true;
            this.deleteTags.tags = item.Tags;
            this.deleteTags.parkId = item.ParkID;
            this.deleteTags.visitDate = item.VisitDate;
            this.deleteTags.uuid = item.uuid;
            this.deleteTags.item = item;
        },
        async tagsToRemove(idx) {
            try {
                this.deleteTags.tags.splice(idx, 1);
                let tags = this.deleteTags.tags;
                
                await this.getAlbumByTag(
                    tags,
                    this.deleteTags.parkId,
                    this.deleteTags.visitDate,
                    true
                );

                Vue.$toast.open({
                    message: this.$t("messages.tag_remove_successfully"),
                    type: "success",
                });
            } catch (error) {
                Vue.$toast.open({
                    message: this.$t("messages.tag_error_remove"),
                    type: "error",
                });

                
            }
        },
    },
};
